import styled from 'styled-components'
import { Layout } from 'antd'

export const PaddedContent = styled(Layout.Content)`
  padding: 1rem;
  min-height: calc(100vh - 120px);
  background-color: white;
`;
